import type { FaireProductEntity } from "../../entity_types/product";

export const p_tr9t3su8hd: FaireProductEntity = {
  token: "p_tr9t3su8hd",
  type: "product",
  name: "Holiday 2026 Stocking Stuffers",
  brandToken: "b_9bs9zcxru5",
  brandName: "The Sensory Riot",
  imageUrl:
    "https://cdn.faire.com/fastly/88d6342208298581c48f74da59fe0307996d5b36d0f9fc0285c92f52548b002a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/625e95ede6760bbd05cb6475ff59afa7e37ae9c4420db01c07562eda76a48aa3.jpeg",
    "https://cdn.faire.com/fastly/1b664ee5f74100a6fb4a53d2c4416be99919afd3d01bfdec75010930d44aea5b.jpeg",
    "https://cdn.faire.com/fastly/ceaf824792c09afadc91facc6676841a4a85912953649dc323af90ae11a98793.jpeg",
    "https://cdn.faire.com/fastly/53d127160b7b5241fad2c25178cf84cd2cac0b4ccd932f245f397de419325c2a.jpeg",
    "https://cdn.faire.com/fastly/0b0a5bcf3a336d7e112010435d2008d6befe2524eac2b0d46f4b61f0b93f64e8.jpeg",
    "https://cdn.faire.com/fastly/1ba87892facdca4a8fd26852c53e054ae8caa1970284d15cd02897caf4b6310b.jpeg",
    "https://cdn.faire.com/fastly/63ba8a41e87245374c014f926922ba616c47bb546406d1b889e3b9728958c5df.jpeg",
  ],
  priceDollars: 396,
  description:
    "The Holiday Stocking Stuffers Collection celebrates the season with festive fragrances designed for effortless gifting, featuring discovery-size candles beautifully packaged and ready for anyone on your list or to elevate at-home entertaining.\n\nGiftable and easy to mix and match, these seasonal fragrances make celebrating the season and spreading holiday cheer simple.\n\n\nTHE STOCKING STUFFER COLLECTION INCLUDES:\n* x6 Discovery Size Pine Valley\n* x6 Discovery Size Frostbite\n* x6 Discovery Size Peppermint Fizz \n* x6 Discovery Size Plum Brûlée \n* x6 Discovery Size Size Pomander\n* x6 Discovery Size Lime Sorbet\n\n\nDETAILS\n* Scented Soy Wax Candle\n* Clean Burning + Non Toxic\n* Braided Cotton Wicks\n* Hand-poured in Los Angeles",
  tags: [],
  msrpDollars: 792,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:22.949Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
